module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-notification', {
    attrs: {
      "type": _vm.type,
      "closable": false
    }
  }, [_c('div', {
    staticClass: "media"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-overlay is-active"
  }, [_c('div', {
    staticClass: "loading-background"
  }), _c('div', {
    staticClass: "loading-icon"
  })]) : _vm._e(), _c('div', {
    staticClass: "media-left"
  }, [_c('b-icon', {
    attrs: {
      "size": "is-large",
      "icon": _vm.icon
    }
  })], 1), _c('div', {
    staticClass: "media-right"
  }, [_vm._t("default", function() {
    return [_c('p', [_vm._v("Nenhum dado a exibir.")])]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768078f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/components/DataNotification.vue
// module id = 405
// module chunks = 56